
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>
<body>
  <div class="content-wrapper " style="height: auto;width: 100%;">
    <div class="d-flex justify-content-center">
      <h5 id="heading" class="text-dark" style="font-size: 20px;">Scannez le qrcode</h5>
      <button type="button"  class="btn btn-link position-absolute" style="top: 10px; right: 10px;" aria-label="Close" (click)="closeModal()" >
        <i class="fas fa-times text-dark" style="font-size: 1.5rem; "></i>
      </button>
    </div>
    
      
  </div><br>

  <div class="d-flex justify-content-center text-center ">
    <ngx-qrcode [width]="400" [scale]="2"  value="{{data}}"  class="text-center qrcode"  cssClass="bshadow"></ngx-qrcode>
  
  </div>
  <div class="d-flex justify-content-center m-3 p-3">
    <button class="btn btn-secondary mr-2" (click)="copyToClipboard()">Copier l'URL</button>
    <button class="btn btn-dark"><a [href]="data" target="_blank">Ouvrir le lien</a>
    </button>
  </div>
</body>
</html>